import { render, staticRenderFns } from "./ProductEditCompositionRow.vue?vue&type=template&id=79ae21ce&scoped=true"
import script from "./ProductEditCompositionRow.vue?vue&type=script&lang=ts"
export * from "./ProductEditCompositionRow.vue?vue&type=script&lang=ts"
import style0 from "./ProductEditCompositionRow.vue?vue&type=style&index=0&id=79ae21ce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ae21ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79ae21ce')) {
      api.createRecord('79ae21ce', component.options)
    } else {
      api.reload('79ae21ce', component.options)
    }
    module.hot.accept("./ProductEditCompositionRow.vue?vue&type=template&id=79ae21ce&scoped=true", function () {
      api.rerender('79ae21ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditCompositionRow.vue"
export default component.exports